import { AxiosResponse } from 'axios'
import sanitize from 'sanitize-html'
import { HttpClient } from '@opallabs/api'

type Params = {
  id: string
  entity: 'moment' | 'story'
  expose: boolean
}

type FetchWorkflow = (params: Params) => Promise<AxiosResponse>

export const fetchWorkflow: FetchWorkflow = ({ id, entity, expose }) => {
  const includeString = `?include=context,stages.assignments.responses&filter[context.${entity}_id]=${id}`
  const requestString = expose
    ? `${includeString}&expose[workflow][meta]`
    : includeString
  return HttpClient().get(
    `${window.location.origin}/workflows/v2/workflows${requestString}`,
    {
      transformResponse: (response) => {
        const parsed = JSON.parse(
          sanitize(response, {
            allowedTags: [],
            allowedAttributes: {},
            disallowedTagsMode: 'recursiveEscape',
          })
        )

        return parsed
      },
    }
  )
}
